import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';
import { Amplify, PubSub } from 'aws-amplify';

// https://docs.amplify.aws/lib/pubsub/subunsub/q/platform/js

export const SubscriptionManager = function() {
	let subscriptionInstance = undefined;
	let iotPluggableAdded = false;
	
	let unsubscribe = function() {
		if(subscriptionInstance !== undefined) {
			subscriptionInstance.unsubscribe();
		}
	};
	
	let subscribe = function(topic, next, error, close, region, endpoint) {
		// Mantener una sola instancia
		unsubscribe();
		
		if(!iotPluggableAdded) {
			const iotConfig = {
				'aws_pubsub_region': region,
				'aws_pubsub_endpoint': endpoint,
			};
			Amplify.addPluggable(new AWSIoTProvider(iotConfig));
			iotPluggableAdded = true;
		}
		
		const subscriptionConfig = {
			'next': next,
			'error': error,
			'close': close,
		};
		
		subscriptionInstance = PubSub.subscribe(topic).subscribe(subscriptionConfig);
	};
	
	return {
		'subscribe': subscribe, 
		'unsubscribe': unsubscribe,
	};
};
